import React, { Ref } from 'react';
import mergeRefs from 'react-merge-refs';

import { CurrencyInput } from '@eika/currency-input';

import { TallValidationType } from '../../types/generated-types';
import { FocusableHtmlElement, useFocusRef } from '../hooks';
import { isCurrentSporsmalValid } from '../reducer/current-steg';
import { updateSvar } from '../reducer/sporsmalsflyt-actions';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { CurrentTallsporsmal } from './tall-types';
import { getFeilmeldingForTallValideringType } from './tall-validation';

import './tall.scss';

interface InputProps {
    value: number;
    onChange: (value: string) => void;
    id: string;
    showFeilmelding: boolean;
    maleenhet?: string;
    tallvalidering: TallValidationType;
    focusOnMount: boolean;
    label?: string;
    sublabel?: string;
    errorRef?: Ref<FocusableHtmlElement>;
}

const TallInput = ({
    id,
    value,
    onChange,
    showFeilmelding,
    maleenhet,
    tallvalidering,
    focusOnMount,
    label,
    sublabel,
    errorRef,
}: InputProps) => {
    const focusRef = useFocusRef<HTMLInputElement>(focusOnMount);

    return (
        <CurrencyInput
            name={`tall-currency-${id}`}
            id={id}
            autoComplete="off"
            className="tall-input"
            value={value}
            suffix={maleenhet ? ` ${maleenhet}` : ''}
            decimalScale={tallvalidering === TallValidationType.Halv ? 1 : 0}
            onChange={(numberFormatValues: { type: string; target: { name: string; value: string | number } }) => {
                onChange(numberFormatValues.target.value.toString());
            }}
            error={showFeilmelding && getFeilmeldingForTallValideringType(tallvalidering)}
            ref={mergeRefs([focusRef, errorRef])}
            label={label}
            sublabel={sublabel}
        />
    );
};

interface TallProps {
    currentSporsmal: CurrentTallsporsmal;
    showFeilmelding: boolean;
    focusOnMount: boolean;
    errorRef?: Ref<FocusableHtmlElement>;
}

export const Tall = ({ currentSporsmal, showFeilmelding, focusOnMount, errorRef }: TallProps) => {
    const dispatch = useSporsmalsflytDispatch();

    const onChange = (value: string) => {
        dispatch(updateSvar(value));
    };

    return (
        <div className="container__standard-width">
            <div className="input-text-container">
                <TallInput
                    id={`tall-sporsmal-${currentSporsmal.sporsmal.id}`}
                    value={currentSporsmal.tall}
                    onChange={onChange}
                    key={`tall-sporsmal-${currentSporsmal.sporsmal.id}`}
                    maleenhet={currentSporsmal.maleenhet}
                    showFeilmelding={showFeilmelding && !isCurrentSporsmalValid(currentSporsmal)}
                    tallvalidering={currentSporsmal.sporsmal.tallvalidering}
                    focusOnMount={focusOnMount}
                    label={currentSporsmal.sporsmal.tittel}
                    errorRef={errorRef}
                    sublabel={currentSporsmal.sporsmal.ingress}
                />
            </div>
        </div>
    );
};
